/* Jordan civil date; no external calendar or customer location needed. */
(() => {
  const zone = 'Asia/Amman';
  const partsFormat = new Intl.DateTimeFormat('en-GB', { timeZone: zone, year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' });
  const labelFormat = new Intl.DateTimeFormat('ar-JO', {timeZone:'UTC', weekday:'long', month:'long', day:'numeric', calendar:'gregory'});
  function calculate(now) {
    const p = Object.fromEntries(partsFormat.formatToParts(now).map(x => [x.type, x.value]));
    const date = new Date(Date.UTC(+p.year, +p.month-1, +p.day));
    date.setUTCDate(date.getUTCDate() + 1);
    if (date.getUTCDay() === 5) date.setUTCDate(date.getUTCDate()+1);
    const remaining = 86400 - (+p.hour*3600 + +p.minute*60 + +p.second);
    const clock = [Math.floor(remaining/3600), Math.floor(remaining%3600/60), remaining%60].map(x=>String(x).padStart(2,'0')).join(':');
    return {date, label:'بوصلك يوم '+labelFormat.format(date), clock};
  }
  function update() {
    const data = calculate(new Date());
    document.querySelectorAll('[data-delivery-countdown]').forEach(el => {
      el.querySelector('[data-delivery-date]').textContent = data.label;
      const clock = el.querySelector('[data-delivery-clock]');
      if (clock) clock.textContent = data.clock;
      el.hidden = false;
    });
  }
  update();
  setInterval(update, 30000);
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  if (typeof module !== 'undefined') module.exports = {calculate};
})();
